import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconTxt: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1141 13.3569C12.4693 13.1438 12.93 13.2589 13.1431 13.6141L14 15.0423L14.8569 13.6141C15.07 13.2589 15.5307 13.1438 15.8859 13.3569C16.2411 13.57 16.3562 14.0307 16.1431 14.3859L14.8746 16.5L16.1431 18.6141C16.3562 18.9693 16.2411 19.43 15.8859 19.6431C15.5307 19.8562 15.07 19.741 14.8569 19.3859L14 17.9577L13.1431 19.3859C12.93 19.741 12.4693 19.8562 12.1141 19.6431C11.7589 19.43 11.6438 18.9693 11.8569 18.6141L13.1254 16.5L11.8569 14.3859C11.6438 14.0307 11.7589 13.57 12.1141 13.3569ZM6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H10C10.4142 13.25 10.75 13.5858 10.75 14C10.75 14.4142 10.4142 14.75 10 14.75H9.25V19C9.25 19.4142 8.91421 19.75 8.5 19.75C8.08579 19.75 7.75 19.4142 7.75 19V14.75H7C6.58579 14.75 6.25 14.4142 6.25 14ZM17.25 14C17.25 13.5858 17.5858 13.25 18 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14C21.75 14.4142 21.4142 14.75 21 14.75H20.25V19C20.25 19.4142 19.9142 19.75 19.5 19.75C19.0858 19.75 18.75 19.4142 18.75 19V14.75H18C17.5858 14.75 17.25 14.4142 17.25 14Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27427 19.823C2.27678 21.4403 3.58211 22.75 5.19144 22.75H16.8328C18.0256 22.75 19.0512 22.0306 19.5034 21C19.5022 21 19.5011 21 19.5 21H8.5C7.39543 21 6.5 20.1046 6.5 19V15.937C5.63739 15.715 5 14.9319 5 14C5 12.8954 5.89543 12 7 12H19.75V9.05498C19.75 8.79546 19.6473 8.5466 19.4645 8.36329L12.6564 1.53551C12.4741 1.35268 12.2271 1.25 11.9695 1.25H5.16717C3.55429 1.25 2.24749 2.56532 2.25 4.18619L2.27427 19.823ZM11.5673 3.20594L17.8043 9.46094H13.0673C12.2389 9.46094 11.5673 8.78936 11.5673 7.96094V3.20594Z"
            fill="currentColor"
          />
        </>
      }
    />
  );
};
